import { IonContent, IonPage } from "@ionic/react";
import React, { useEffect, useState } from "react";
import BackButton from "../../components/common/BackButton";
import { useSelector } from "react-redux";
import navigoServices from "../../services/NavigoServices";
import moment from "moment";
import { HistoryCard } from "./components/historyCard";
import "./index.scss";
import { NoAppointmentFound } from "../navigo/components/noAppointmentFound";
import { CircularProgress } from "@mui/material";
import CommonHeader from "../../CommonHeader";

const BookingHistory = () => {
  const user = useSelector((store) => store.login.user);
  const [allAppoints, setAllAppoints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [isPB, setIsPB] = useState(false);

  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);

  useEffect(() => {
    handleBookingHistory(pageNum);
  }, [pageNum]);

  const handleBookingHistory = (page = 1) => {
    const patientProfileId = user?.patientProfile?.id;

    const payload = {
      appointmentDate: null,
      appointmentId: 0,
      bookedForID: [],
      pageNum: page,
      pageSize: pageSize,
      patientId: patientProfileId,
      range: "",
      serviceTypeID: [],
      statusOrderSort: false,
      year: 0,
    };

    setLoading(true);

    navigoServices
      .getAllAppointmentsByPatientId(payload)
      .then((res) => {
        const result = res.data;

        setTotalCount(result?.totalCount || 0);

        if (result?.appointments?.length > 0) {
          const formattedAppointments = result.appointments.map((appoint) => ({
            ...appoint,
            appointmentDate: moment(appoint.appointmentDate).format(
              "DD MMM, YYYY",
            ),
            bookingDate: moment(appoint.bookingDate).format("DD MMM, YYYY"),
          }));

          setAllAppoints(formattedAppointments);
        } else {
          setAllAppoints([]);
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setAllAppoints([]);
      });
  };
  return (
    <IonPage>
      {isPB && <CommonHeader />}
      <IonContent style={{ "--background": "#F8F9FA" }}>
        {loading ? (
          <CircularProgress
            className="ion-router-circular-progress"
            style={{ marginTop: "200px" }}
          />
        ) : (
          <div className="booking-history-container">
            <div className="booking-history-back-button">
              {/* <BackButton /> */}
              <p>My appointments</p>
            </div>

            {/* SCROLLABLE LIST */}
            <div className="booking-history-card-container">
              {allAppoints &&
                allAppoints.length > 0 &&
                allAppoints.map((appoint) => (
                  <HistoryCard
                    key={appoint.id}
                    appointmentId={appoint.id}
                    patientName={appoint.patientName}
                    name={appoint.serviceName}
                    consultDate={appoint.appointmentDate}
                    bookDate={appoint.bookingDate}
                    bookingId={appoint.id}
                    status={appoint.status}
                    patientId={user?.patientProfile?.id}
                    appointmentData={appoint}
                    onRefresh={() => handleBookingHistory(pageNum)}
                  />
                ))}

              {allAppoints && allAppoints.length === 0 && (
                <NoAppointmentFound msg={"No previous booking found!"} />
              )}
            </div>

            {/* FIXED PAGINATION */}
            {totalCount > pageSize && (
              <div className="pagination-fixed">
                <div className="pagination-container">
                  <div
                    className={`page-box arrow ${
                      pageNum === 1 ? "disabled" : ""
                    }`}
                    onClick={() =>
                      pageNum > 1 && setPageNum((prev) => prev - 1)
                    }
                  >
                    &#8249;
                  </div>

                  <div className="page-box active">{pageNum}</div>

                  <span className="page-text">of</span>

                  <div className="page-box total">
                    {Math.ceil(totalCount / pageSize)}
                  </div>

                  <div
                    className={`page-box arrow ${
                      pageNum * pageSize >= totalCount ? "disabled" : ""
                    }`}
                    onClick={() =>
                      pageNum * pageSize < totalCount &&
                      setPageNum((prev) => prev + 1)
                    }
                  >
                    &#8250;
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default BookingHistory;
